import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/firestore';
import { Product } from './product.model';

@Injectable({
  providedIn: 'root'
})

export class ProductService {

  constructor(private fireStore: AngularFirestore) { }

  // Student form data.
  formData: Product;

  // Fetch all students information.
  getAllProducts() {
    // valueChanges() function returns the observable containing the student details expect the id of the document.
    // snapshotChanges() function returns the observable containing the student details and the id of the document (i.e. the metadata).
    return this.fireStore.collection('products').snapshotChanges();

    // We will use the id in order to perform the update or delete operation.
  }
}
